import React from "react";
import { ProgressBar } from "react-bootstrap";
import { SchoolIcon } from "../../../styles/img/svg/SchoolIcon";
import { SherbetEyeIcon } from "../../../styles/img/svg/SherbetEyeIcon";
import { WorldIcon } from "../../../styles/img/svg/WorldIcon";
import { UiSplitImages } from "../common/UiSplitImages";
import { transactionType} from "../../../_redux/_constants"


export const UiPointsItem = (props) => {
    return (
        <>
            <div className="sb-info-card__content__points__item">
                <div className="sb-info-card__content__points__item__left">
                    <p className="sb-info-card__content__points__item__left__date">{props.date}</p>
                    {/* The value is the transaction description written by the campaign that paid
                        the points, for example "Q3 Sales Prize Draw Incentive - WK1". It is a
                        sentence, not an identifier, so it is rendered exactly as stored. */}
                    <p className="sb-info-card__content__points__item__left__id"><span>{props.id}</span></p>
                </div>
                <div className="sb-info-card__content__points__item__right">
                    <p>{props.transactionType == transactionType.CREDIT ? '+' : "-"} {props.points} Points</p>
                </div>
            </div>
        </>
    )
}

export const UiWishListItem = (props) => {
    return (
        <>
            <div className="sb-info-card__content__wishlist-item">
                {props.children}
            </div>
        </>
    )
}

export const UiGoalsItem = (props) => {
    return (
        <>
            <div className="sb-info-card__content__goals-item">
                <h5>{props.title}</h5>
                <p>{props.description}</p>

                {props.splitTeam &&
                    <div className="sb-info-card__content__goals-item__split">
                        <UiSplitImages images={props.images} />
                        <p>{props.team}</p>
                    </div>
                }

                <div className="sb-info-card__content__goals-item__progress-bar">
                    <div className="sb-info-card__content__goals-item__progress-bar__wrapper">
                        <ProgressBar now={props.progressVal} /> <label>{props.progressVal}%</label>
                    </div>
                    <p>
                        {props.progressInfo}
                    </p>
                </div>

            </div>
        </>
    )
}

export const UiProfileItem = (props) => {
    return (
        <>
            <div className="sb-info-card__content__profile-item">
                <div className="sb-info-card__content__profile-item__header">
                    <img src={props.profileImage} className="sb-info-card__content__profile-item__header__profile-img" />
                    <div className="sb-info-card__content__profile-item__header__name">
                        <h4>{props.username}</h4>
                        <p>{props.points}</p>
                    </div>
                    <div className="sb-info-card__content__profile-item__header__title">
                        <SherbetEyeIcon />
                        <span>{props.position}</span>
                    </div>

                </div>

                <div className="sb-info-card__content__profile-item__content">
                    <h3 className="sb-info-card__content__profile-item__content__header">{props.fullName}</h3>

                    <div className="sb-info-card__content__profile-item__content__info-label">
                        <div>
                            <WorldIcon />
                            <p>{props.location}</p>
                        </div>

                        <div>
                            <SchoolIcon />
                            <p>{props.university}</p>
                        </div>
                    </div>

                    <p className="sb-info-card__content__profile-item__content__desc">
                        {props.description}
                    </p>
                </div>

                <div className="sb-info-card__content__profile-item__footer">
                    <div className="sb-info-card__content__profile-item__footer__desc">
                        {props.footerDesc}
                    </div>
                    <div className="sb-info-card__content__profile-item__footer__images">
                        <UiSplitImages images={props.images} />
                        <p>{props.badgeNote}</p>
                    </div>
                </div>

            </div>
        </>
    )
}